<template>
  <div>
    <label>Merge Fields</label>
    <ul>
      <li v-for="field in mergeFields" :key="field">
        {{ '{' + field + '}' }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EmailTemplateMergeFields',
  props: {
    mergeFields: {
      type: Array,
      required: true
    }
  }
}
</script>
